import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';
import { ContractProvider } from './context/ContractContext';

// Componentes de páginas
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';

// Componentes de contratos
import ContractForm from './components/contracts/ContractForm';
import EbesSolarForm from './components/contracts/EbesSolarForm';
import EbesPDFGeneratorPage from './components/contracts/EbesPDFGeneratorPage';

// Admin
import AdminPanel from './components/admin/AdminPanel';

// Componente de proteção de rotas
import ProtectedRoute from './components/ProtectedRoute';

// Layout
import Header from './components/layout/Header';

// Componente para redirecionar baseado no template do usuário
const ContractRouter = () => {
  const { userTemplate } = useAuth();
  
  if (userTemplate === 'ebes_solar') {
    return <EbesSolarForm />;
  }
  
  return <ContractForm />;
};

// Página de sucesso temporária
const ContractSuccessPage = () => (
  <div className="min-h-screen bg-neutral-50">
    <Header />
    <div className="flex items-center justify-center py-12">
      <div className="bg-white rounded-lg shadow-sm border p-8 text-center max-w-md">
        <div className="text-green-500 text-6xl mb-4">✓</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Contrato Gerado com Sucesso!
        </h1>
        <p className="text-gray-600 mb-6">
          Seu contrato foi criado e está pronto para download.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => window.location.href = '/contratos/novo'}
            className="w-full bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          >
            Criar Novo Contrato
          </button>
          <button
            onClick={() => window.location.href = '/dashboard'}
            className="w-full bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300"
          >
            Voltar ao Dashboard
          </button>
        </div>
      </div>
    </div>
  </div>
);

function App() {
  return (
    <AdminProvider>
      <AuthProvider>
        <ContractProvider>
          <Router>
            <div className="App min-h-screen bg-neutral-50">
              <Routes>
                {/* Rotas públicas */}
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                
                {/* Rotas protegidas */}
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } 
                />
                
                <Route 
                  path="/contratos/novo" 
                  element={
                    <ProtectedRoute>
                      <ContractRouter />
                    </ProtectedRoute>
                  } 
                />
                
                <Route 
                  path="/contratos/sucesso" 
                  element={
                    <ProtectedRoute>
                      <ContractSuccessPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Rota específica para geração de PDF EBES Solar */}
                <Route 
                  path="/contratos/gerar-ebes" 
                  element={
                    <ProtectedRoute>
                      <EbesPDFGeneratorPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Rota do Admin */}
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute>
                      <AdminPanel />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Rota para páginas não encontradas */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </Router>
        </ContractProvider>
      </AuthProvider>
    </AdminProvider>
  );
}

export default App;